<script setup>
  import { $vfm, VueFinalModal, ModalsContainer } from 'vue-final-modal';
</script>

<script>
export default {
  inheritAttrs: false,
  components: {
    ModalsContainer
  }
}
</script>

<template>
  <vue-final-modal
    name="CustomModal"
    v-slot="{ params, close }"
    v-bind="$attrs"
    :hide-overlay="true"
    :drag="true"
    classes="modal-container"
    content-class="modal-content"
  >
    <span class="modal__title">
      <slot name="title"></slot>
    </span>
    <div class="modal__content">
      <slot name="content" v-bind:params="params"></slot>
    </div>
    <div class="modal__action">
    <slot name="action" v-bind:params="params">
    </slot>
    </div>
    <button class="modal__close" @click="close">
    <span class="screen-size-icon screen-size-icon-first fas fa-times" style="float:right;color:#0072c5;"></span>
    </button>
  </vue-final-modal>
</template>

<style scoped>
:deep .modal-container {
  display: flex;
  justify-content: center;
  align-items: center;
}
:deep .modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  max-height: 70%;
  margin: 0 1rem;
  padding: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  background: #fff;
  width: 50%;
}
.modal__title {
  border-bottom:1px solid #e2e8f0;
  width:100%;
  margin: -15px 2rem 0 0;
  font-size: 1.0rem;
  font-weight: 300;
  width: 100%;
  height: 20px;
  cursor: pointer;
  color: #0072c5;
  white-space: nowrap;
  align-items: center;
  font-family: Roboto,Arial,Tahoma,Verdana,sans-serif!important;
  height: 39px;
  color: #0072c5;
  display: flex;
  white-space: nowrap;
  align-items: center;
  font-family: Roboto,Arial,Tahoma,Verdana,sans-serif!important;
}
.modal__content {
  flex-grow: 1;
}
.modal__action {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  padding: 1rem 0 0;
  margin-left: 145px;
  height: 25px;
  color: #fff;
  display: flex;
  white-space: nowrap;
  align-items: center;
  font-family: Roboto,Arial,Tahoma,Verdana,sans-serif!important;
}

.ButtonText{
margin-left: 145px;
height: 25px;
background-color: #0072c5;
color: #fff;
display: flex;
white-space: nowrap;
align-items: center;
font-family: Roboto,Arial,Tahoma,Verdana,sans-serif!important;
}

.modal__close {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
}
</style>

<style scoped>
.dark-mode div:v-deep .modal-content {
  border-color: #2d3748;
  background-color: #1a202c;
}
</style>
